import MarkdownContentRenderer from 'fitify-ui-landing/src/components/Markdown/MarkdownContentRenderer'
import type { NextPage } from 'next'
import { useTranslation } from 'next-i18next'

import { Layout } from '@/components/layouts/Layout'
import { getStaticPropsTranslations } from '@/utils/i18n'

import content from '../../public/assets/markdown/behavioral-science-approach.md'

const BehavioralSciencePage: NextPage = () => {
  const { t } = useTranslation()
  return (
    <Layout
      seo={{
        title: 'Our Approach to Behavioral Science | Nutria',
        description: t('cl_landing_behavioral_science_meta_description'),
      }}
    >
      <MarkdownContentRenderer content={content} />
    </Layout>
  )
}

export default BehavioralSciencePage

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await getStaticPropsTranslations(locale)),
    },
  }
}
